import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvListValue,
    DetailPanel,
    DetailKvTable,
    DetailSummaryButton,
    KV_LIST_TYPES,
} from '../../../../components/detailLayout';
import React, {useMemo} from "react";
import Th_title from "../../../../components/Th_title";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {removeWorks} from "../../../../api/maintenance/WorkService";
import {useNavigate} from "react-router-dom";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {TaskManager} from "../../shared/TaskManager";
import {MemoList} from "../../../../components/memo/MemoList";
import {connectedInfoRadio} from "../WorkCreate";
import {isEmpty, isMobile} from "../../../../components/commonmethod/CommonMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {cn} from "../../../../shadCn/lib/utils";

function WorkInfo({id, work, assets, handler, statusNumericValue}) {
    const navigate = useNavigate();

    const remove = async () => {
        const response = await removeWorks({ids: [id]});
        if (response === 200) {
            alert("작업이 정상적으로 삭제되었습니다.");
            navigate("/maintenance/work");
        }
    };

    function goInfo() {
        switch (work.connectedInfo) {
            case ContentCategory.SERVICE_REQUEST:
                navigate(`/serviceRequest/serviceRequest/${work.service.id}`);
                break;
            case ContentCategory.INSPECTION:
                navigate(`/maintenance/inspection/${work.inspect.id}`);
                break;
            case ContentCategory.INCIDENT:
                navigate(`/maintenance/incident/${work.incident.id}`);
                break;
            default:
                break;
        }
    }

    const summaryMeta = [
        work.workCode?.name && `코드 ${work.workCode.name}`,
        work.number && `번호 ${work.number}`,
    ].filter(Boolean).join(" · ");

    const canAccept = work.auth?.update && statusNumericValue === ContentStatus.PRE_INSERT.statusNumericValue;

    const headerActions = useMemo(() => (
        canAccept ? (
            <DetailSummaryButton onClick={() => navigate(`/maintenance/work/update/${id}`)}>
                접수하기
            </DetailSummaryButton>
        ) : null
    ), [canAccept, id, navigate]);

    const rollupConfig = useMemo(() => ({
        cancel: {url: "/maintenance/work"},
        data: work,
        remove: !isMobile && work.auth?.delete && statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue
            ? remove
            : "",
    }), [work, statusNumericValue]);

    const requestInfoPanel = (
        <DetailPanel title={"작업요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"작업연계정보"} colspan={3} className="fieldset-td relative align-top">
                            <div className="flex items-center space-x-0">
                                <div style={{flex: '1 1 auto', maxWidth: '200px'}}>
                                    <ReadOnlyInputBasic
                                        target={"connectedInfo"}
                                        value={connectedInfoRadio.find((each) => each.value === work.connectedInfo)?.text}
                                    />
                                </div>
                                {work.connectedInfo !== ContentCategory.NONE &&
                                    (!isEmpty(work.service) || !isEmpty(work.inspect) || !isEmpty(work.incident)) && (
                                        <button
                                            onClick={goInfo}
                                            className={`flex items-center px-2 py-0 text-sm border rounded bg-white hover:bg-gray-100 ${isMobile && "1"}`}
                                            style={{marginLeft: '0'}}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-4 w-4 mr-1"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M13.828 12l4.95-4.95m0 0a3.5 3.5 0 00-4.95-4.95m4.95 4.95L12 13.828m0 0L7.05 8.879m0 0a3.5 3.5 0 010 4.95m0 0L12 13.828"
                                                />
                                            </svg>
                                            <span>바로가기</span>
                                        </button>
                                    )}
                            </div>
                        </Th_title>
                    </tr>
                    {!work?.connectedId || !work?.connectedInfo ? (
                        <tr>
                            <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                <div>연계정보 없음</div>
                            </Th_title>
                        </tr>
                    ) : !isEmpty(work.service) || !isEmpty(work.inspect) || !isEmpty(work.incident) ? (
                        <tr>
                            <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                <div>
                                    제목 :{' '}
                                    {work.connectedInfo === ContentCategory.SERVICE_REQUEST
                                        ? work.service?.title
                                        : work.connectedInfo === ContentCategory.INSPECTION
                                          ? work.inspect?.title
                                          : work.connectedInfo === ContentCategory.INCIDENT
                                            ? work.incident?.title
                                            : ""}
                                </div>
                                <div>
                                    등록일 :{' '}
                                    {work.connectedInfo === ContentCategory.SERVICE_REQUEST
                                        ? work.service?.createdAt
                                        : work.connectedInfo === ContentCategory.INSPECTION
                                          ? work.inspect?.createdAt
                                          : work.connectedInfo === ContentCategory.INCIDENT
                                            ? work.incident?.createdAt
                                            : ""}
                                </div>
                                <div>
                                    수정일 :{' '}
                                    {work.connectedInfo === ContentCategory.SERVICE_REQUEST
                                        ? work.service?.updatedAt
                                        : work.connectedInfo === ContentCategory.INSPECTION
                                          ? work.inspect?.updatedAt
                                          : work.connectedInfo === ContentCategory.INCIDENT
                                            ? work.incident?.updatedAt
                                            : ""}
                                </div>
                            </Th_title>
                        </tr>
                    ) : (
                        <tr>
                            <Th_title title={"연계정보"} colspan={3} className="fieldset-td relative align-top">
                                <div>삭제된 정보입니다.</div>
                            </Th_title>
                        </tr>
                    )}
                    <tr>
                            <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdAt"} value={work.createdAt} />
                            </Th_title>
                            <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdBy"} value={work.createdBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedAt"} value={work.updatedAt} />
                            </Th_title>
                            <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedBy"} value={work.updatedBy} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"requester"} value={work.requester} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업종류"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workCode"} value={work?.workCode?.name} />
                            </Th_title>
                            <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workRequest"} value={work.workRequest} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업인지"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"workAcceptCode"} value={work.workAcceptCode} />
                                <ReadOnlyInputBasic target={"workAcceptText"} value={work.workAcceptText} />
                            </Th_title>
                            <Th_title title={"작업위치"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"location"} value={work.location} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업기간"} colspan={3} className="fieldset-td fieldset-td-input">
                                <div className={"web-flex"}>
                                    <SimmsDatePicker data={work.workStartDate} readonly />
                                    <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                    <SimmsDatePicker data={work.workEndDate} readonly />
                                </div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업 제목"} colspan={3} className="fieldset-td">
                                <div className={`p-1`}>{work.title}</div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"작업내용"} colspan={3} className="fieldset-td">
                                <div className={`align-text-div`}>{work.workContent}</div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"SLA 사용여부"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"useSla"} value={work.useSla ? "사용함" : "사용 안함"} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"비고"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"etc"} value={work.etc} />
                            </Th_title>
                        </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const workflowPanels = (
        <>
            <TaskManager
                data={work}
                contentCategory={ContentCategory.WORK}
                statusRows={(
                    <>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"inspector"} value={work.inspector} />
                            </Th_title>
                        </tr>
                    </>
                )}
            />

        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent contentId={work.id} contentCategory={ContentCategory.WORK_PRE_APPROVE} />
            <ApprovalComponent
                contentId={work.id}
                contentCategory={ContentCategory.WORK_POST_APPROVE}
                title={"사후결재"}
                approvalSeparator={true}
            />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(work.auth?.update)}
                tableInfo={{tableName: "Work", joinKey: id}}
            />
            <MemoList entityId={work.id} entityName={"Work"} />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={work.title || "작업 상세"}
            meta={summaryMeta || undefined}
            contentId={id}
            contentCategory={ContentCategory.WORK}
            scrollMode="columns"
            listUrl="/maintenance/work"
            actions={headerActions}
            rollup={rollupConfig}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={workflowPanels}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {WorkInfo};
